import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { ETipScheme } from 'components/settings/enums';
import { useCurrencyString } from 'lib/useCurrencyString';

const StyledBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'isLast' && prop !== 'selected'
})<{
    isLast: boolean;
    selected: boolean;
}>(({ theme, isLast, selected }) => ({
    flex: 1,
    padding: theme.spacing(1),
    ...(!isLast && {
        borderRight: `1px solid ${theme.palette.primary.main}`
    }),
    ...(selected && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.getContrastText(theme.palette.primary.main)
    })
}));

interface IProps {
    value: number;
    scheme: ETipScheme;
    isLast: boolean;
    onClick: (value: number) => void;
    selected: boolean;
}

export const ViewBillTipSelectorItem: React.FC<React.PropsWithChildren<IProps>> = ({
    value,
    scheme,
    isLast,
    onClick,
    selected
}) => {
    const getCurrencyString = useCurrencyString();
    const tipString = React.useMemo(() => {
        if (scheme === ETipScheme.PERCENTAGE) {
            return `${value}%`;
        }
        return getCurrencyString(value);
    }, [getCurrencyString, scheme, value]);
    const handleSelectorClick = React.useCallback(() => onClick(value), [onClick, value]);

    return (
        <StyledBox onClick={handleSelectorClick} isLast={isLast} selected={selected}>
            {tipString}
        </StyledBox>
    );
};
